// M-MODE
export const MModeFields = [
  { title: "LVEDD", range: "34–52 mm", resultCount: 2 }, //result Count
  { title: "LVESD", range: "(mm)", resultCount: 2 },
  { title: "IVS (D)", range: "8–11 mm", resultCount: 2 },
  { title: "IVS (S)", range: "(mm)", resultCount: 2 },
  { title: "LVPW (D)", range: "6–11 mm", resultCount: 2 },
  { title: "LVPW (S)", range: "(mm)", resultCount: 2 },
  { title: "LA (D)", range: "23–38 mm" },
  { title: "Ao (D)", range: "21–35 mm" },
  { title: "Sinus", range: "" },
  { title: "Sino-tubular", range: "" },
  { title: "Asc. Ao", range: "" },
  { title: "EPSS", range: ">10 mm" },
];

export default MModeFields;
